<template>
  <div>
    <!-- step2 -->
    <div class="step">
      <!-- 상단 페이지명, 스텝 -->
      <div class="top-wrap" flex fjb>
        <div class="step-title">
          {{ "본인 인증" }}
        </div>
        <div class="step-number" flex>
          <div class="number active">1</div>
          <div class="number active ml8">2</div>
          <div class="number ml8">3</div>
          <div class="number ml8">4</div>
        </div>
      </div>
      <!-- //상단 페이지명, 스텝 -->

      <!-- 하단 콘텐츠 -->
      <div class="bottom-wrap pt20">
        <top-noti :topcontent="topcontent"></top-noti>

        <!-- ocr version -->
        <div class="mt20">
          <div class="phone-wrap mt20">
            <p>{{ "1. 휴대폰 본인인증" }}</p>
            <button
              :disabled="data.niceResult"
              @click="AuthPhoneNumber"
              class="next-button"
            >
              {{ data.niceResult ? data.mobileNo : "휴대폰 인증하기" }}
            </button>
          </div>
          <div class="camera-wrap mt20">
            <p>{{ "2. 신분증 인증" }}</p>
            <p class="fs12 keycolor">
              * 신분증 촬영 후 인증에 시간이 소요될 수 있습니다.
            </p>
            <ocr-module :data.sync="data" :step2data="data"></ocr-module>
          </div>
          <div class="bottom-button-wrap bottom" flex fjb>
            <button disabled class="next-button pre">
              {{ "이전" }}
            </button>
            <button
              @click="toConfirm2"
              :disabled="data.mobileNo == '' || data.ocrResult !== 'Success'"
              class="next-button next"
            >
              {{ "다음" }}
            </button>
          </div>
        </div>
        <!-- // ocr version -->
      </div>
      <!-- //하단 콘텐츠 -->
    </div>
    <!-- //신원인증 시작. step2 -->
  </div>
</template>
<script>
import topNoti from "../../authIdentity/top-noti.vue";
import ocrModule from "../../authIdentity/ocrModule.vue";
import notiMykeepin from "../../authIdentity/noti-mykeepin.vue";
import Api from "@/common/Api";
import axios from "axios";
import moment from "moment";

export default {
  components: {
    topNoti,
    notiMykeepin,
    ocrModule,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {
          // ocr version
          maskingImage: String,
          cropImage: String,
          formCode: String,
          formName: String,
          confirm: Boolean,
          fullIdNum: String, // 주민등록번호 전체
          birth: String, //생년월일
          inIdNum: String, // 주민등록번호 뒷자리
          driverLicenseNo: String, //운전면허 번호
          serialNo: String, //식별 번호,
          // nice res
          getBirthDate: String, // 생년월일 8자리
          ci: String, // null
          di: String, // string
          getGender: String, // F/M
          mobileNo: String, // 휴대폰 번호
          getName: String, // 이름
          nationalInfo: String, // Y/N
          niceResult: Boolean, // nice 성공/실패
          ocrResult: String, // ocr 성공/실패 코드
        };
      },
    },
  },
  data() {
    return {
      topcontent:
        "특정 금융거래정보의 이용 및 보호 등에 관한 법률 및 동법 시행령에 따라 고객 확인제도 이행 등을 위한 본인 인증을 해주세요.",
      url: "",
    };
  },
  created() {
    window.scrollTo(0, 0);
    window.sendResult = this.recieveResult;
  },
  mounted() {
    this.data.ocrResult = "";
  },
  methods: {
    // 기본정보로 이동
    toStep1() {
      this.$emit("tostep1");
    },
    // ocr 진위여부 페이지
    toConfirm2() {
      this.$emit("toconfirm2");
    },
    //ocr version
    AuthPhoneNumber() {
      const { hostname } = window.location;
      if (this.$isDevServer) {
        this.url = "https://api.dev.flybit.com/v1/auth/cdd-edd/nice/view/W";
      } else if (hostname == "m.v1.flybit.com") {
        this.url = "https://api.v1.flybit.com/v1/auth/cdd-edd/nice/view/W";
      } else {
        this.url = "https://api.flybit.com/v1/auth/cdd-edd/nice/view/W";
      }
      window.open(
        this.url,
        "chkPopup",
        "width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no"
      );
    },
    recieveResult(result, niceVO, message) {
      // console.log(result, niceVO)로 값 확인 안 됨. alert로 확인할 것
      if (!result) {
        // alert(message);
        this.$vs.notify({
          title: this.$t("notice.title.error"),
          text: message,
          color: "danger",
          position: "top-right",
        });
      } else {
        (this.data.getBirthDate = niceVO.birthDate), // 생년월일 8자리
          (this.data.ci = niceVO.ci), // null
          (this.data.di = niceVO.di), // string
          (this.data.getGender = niceVO.gender), // F/M
          (this.data.mobileNo = niceVO.mobileNo),
          (this.data.getName = niceVO.name),
          (this.data.nationalInfo = niceVO.nationalInfo), // Y/N
          (this.data.niceResult = result); // nice 성공/실패
        this.data.phoneCerDate = moment().format("YYYY-MM-DD hh:mm:ss");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.defaultColor {
  color: #333;
}
.content-wrap {
  position: relative;
  padding: 12px;
  min-height: 520px;
  /* font-size: 12px; */
  color: #333;
  .step {
    .top-wrap {
      .step-title {
        font-size: 14px;
        font-weight: 500;
      }
    }
    .bottom-wrap {
      position: relative;
      min-height: 476px;
    }
    .noti-try {
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      color: #333333;
    }
    .round-button-wrap {
      position: relative;
      // height: 84px;
      .round-button {
        width: 50%;
        padding: 0 15px;
        border-radius: 162px;
        border: solid 1px #dcdfe3;
        background-color: #ffffff;
        .text-wrap {
          margin: 20px 0;
          span {
            margin: 0 auto;
          }
          img {
            margin: 0 auto;
          }
        }
      }
    }
    .content-wrap {
      .item {
        .title {
          margin-bottom: 8px;
        }
        .button-wrap {
          .detail-noti {
            color: #afafaf;
          }
        }
      }
    }
    .center-content-wrap {
      position: relative;
      height: 390px;
      .content {
        position: absolute;
        top: 60px;
        left: 50%;
        transform: translateX(-50%);
        .round {
          width: 58px;
          height: 58px;
          margin-left: 44px;
          padding: 16px 16px 16px;
          border: solid 1px rgba(51, 51, 51, 0.1);
          background-color: #fff;
        }
        &.full {
          position: relative;
          width: 100%;
          padding-top: 64px;
          img {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }
  }
  // step number
  .step-number {
    .number {
      width: 20px;
      height: 20px;
      text-align: center;
      color: #dcdfe3;
      border-radius: 2px;
      background-color: #f7f8fa;
      &.active {
        color: #fff;
        background-color: #333;
      }
    }
  }
  // 하단 버튼
  button.next-button {
    width: 100%;
    padding: 10px 0;
    /* font-size: 12px; */
    border-radius: 2px;
    border: 1px solid #00b473;
    background-color: #00b473;
    &.pre {
      width: 96px;
      color: #333;
      border: 1px solid #eeeeee;
      background-color: #fff;
      &:disabled {
        border: solid 1px #dadada !important;
        background-color: #dadada !important;
      }
    }
    &.next {
      width: calc(100% - 104px);
      &.red {
        border-color: #eb3264;
        background-color: #eb3264;
      }
    }
    &.bottom {
      position: absolute;
      bottom: 32px;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% - 24px);
    }
    &:disabled {
      border: solid 1px #dadada !important;
      background-color: #dadada !important;
    }
  }
  .bottom-button-wrap {
    width: 100%;
    &.bottom {
      position: absolute;
      bottom: 0;
    }
  }
}
</style>
